/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Measure_Unit_Request_OneInputs */

const en_measure_unit_request_one = /** @type {(inputs: Measure_Unit_Request_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} request`)
};

const zh_hans1_measure_unit_request_one = /** @type {(inputs: Measure_Unit_Request_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 次请求`)
};

const pt_br2_measure_unit_request_one = /** @type {(inputs: Measure_Unit_Request_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} requisição`)
};

const es_measure_unit_request_one = /** @type {(inputs: Measure_Unit_Request_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} solicitud`)
};

const fr_measure_unit_request_one = /** @type {(inputs: Measure_Unit_Request_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} requête`)
};

const de_measure_unit_request_one = /** @type {(inputs: Measure_Unit_Request_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Anfrage`)
};

const ru_measure_unit_request_one = /** @type {(inputs: Measure_Unit_Request_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} запрос`)
};

const it_measure_unit_request_one = /** @type {(inputs: Measure_Unit_Request_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} richiesta`)
};

/**
* | output |
* | --- |
* | "{count} request" |
*
* @param {Measure_Unit_Request_OneInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_unit_request_one = /** @type {((inputs: Measure_Unit_Request_OneInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Unit_Request_OneInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_unit_request_one(inputs)
	if (locale === "pt-BR") return pt_br2_measure_unit_request_one(inputs)
	if (locale === "es") return es_measure_unit_request_one(inputs)
	if (locale === "fr") return fr_measure_unit_request_one(inputs)
	if (locale === "de") return de_measure_unit_request_one(inputs)
	if (locale === "ru") return ru_measure_unit_request_one(inputs)
	if (locale === "it") return it_measure_unit_request_one(inputs)
	return en_measure_unit_request_one(inputs)
});